import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_2 = { class: "flex flex-wrap gap-3" }
const _hoisted_3 = { class: "inline-flex items-center ml-3 space-x-2" }
const _hoisted_4 = { class: "inline-flex items-center ml-3 space-x-2" }
const _hoisted_5 = {
  key: 0,
  class: "mt-3 px-3 py-2 bg-gray-800 rounded-lg text-sm text-gray-300"
}
const _hoisted_6 = { class: "font-medium text-blue-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.stats)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => {
          _ctx.$emit('change-role', 'seller');
          _ctx.$emit('change-filter', 'all');
        }),
            class: _normalizeClass(["px-5 py-3 rounded-lg text-white font-medium transition-colors flex items-center", 
          _ctx.userRole === 'seller'
            ? 'bg-gray-700 hover:bg-gray-600'
            : 'bg-gray-800 hover:bg-gray-700'
        ])
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "Kao prodavac", -1)),
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {
              _ctx.$emit('change-role', 'seller');
              _ctx.$emit('change-filter', 'positive');
            }, ["stop"])),
                class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded", {
              'bg-green-800 text-green-200':
                _ctx.userRole === 'seller' && _ctx.activeFilter === 'positive',
              'hover:bg-gray-600': !(
                _ctx.userRole === 'seller' && _ctx.activeFilter === 'positive'
              ),
            }])
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "mr-1" }, "👍", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.stats.seller.likes), 1)
              ], 2),
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {
              _ctx.$emit('change-role', 'seller');
              _ctx.$emit('change-filter', 'negative');
            }, ["stop"])),
                class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded", {
              'bg-red-800 text-red-200':
                _ctx.userRole === 'seller' && _ctx.activeFilter === 'negative',
              'hover:bg-gray-600': !(
                _ctx.userRole === 'seller' && _ctx.activeFilter === 'negative'
              ),
            }])
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "mr-1" }, "👎", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.stats.seller.dislikes), 1)
              ], 2)
            ])
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => {
          _ctx.$emit('change-role', 'buyer');
          _ctx.$emit('change-filter', 'all');
        }),
            class: _normalizeClass(["px-5 py-3 rounded-lg text-white font-medium transition-colors flex items-center", 
          _ctx.userRole === 'buyer'
            ? 'bg-gray-700 hover:bg-gray-600'
            : 'bg-gray-800 hover:bg-gray-700'
        ])
          }, [
            _cache[12] || (_cache[12] = _createElementVNode("span", null, "Kao kupac", -1)),
            _createElementVNode("span", _hoisted_4, [
              _createElementVNode("span", {
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => {
              _ctx.$emit('change-role', 'buyer');
              _ctx.$emit('change-filter', 'positive');
            }, ["stop"])),
                class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded", {
              'bg-green-800 text-green-200':
                _ctx.userRole === 'buyer' && _ctx.activeFilter === 'positive',
              'hover:bg-gray-600': !(
                _ctx.userRole === 'buyer' && _ctx.activeFilter === 'positive'
              ),
            }])
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "mr-1" }, "👍", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.stats.buyer.likes), 1)
              ], 2),
              _createElementVNode("span", {
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => {
              _ctx.$emit('change-role', 'buyer');
              _ctx.$emit('change-filter', 'negative');
            }, ["stop"])),
                class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded", {
              'bg-red-800 text-red-200':
                _ctx.userRole === 'buyer' && _ctx.activeFilter === 'negative',
              'hover:bg-gray-600': !(
                _ctx.userRole === 'buyer' && _ctx.activeFilter === 'negative'
              ),
            }])
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "mr-1" }, "👎", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.stats.buyer.dislikes), 1)
              ], 2)
            ])
          ], 2),
          (_ctx.activeFilter !== 'all')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('change-filter', 'all'))),
                class: "px-5 py-3 rounded-lg bg-blue-600 hover:bg-blue-500 text-white font-medium transition-colors"
              }, " Prikaži sve ocene "))
            : _createCommentVNode("", true)
        ]),
        (_ctx.activeFilter !== 'all')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[13] || (_cache[13] = _createTextVNode(" Prikazuju se samo ")),
              _createElementVNode("span", {
                class: _normalizeClass(["font-medium", _ctx.activeFilter === 'positive' ? 'text-green-400' : 'text-red-400'])
              }, _toDisplayString(_ctx.activeFilter === 'positive' ? 'pozitivne' : 'negativne'), 3),
              _cache[14] || (_cache[14] = _createTextVNode(" ocene kao ")),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userRole === 'seller' ? 'prodavac' : 'kupac'), 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}